import React, { FC, useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useOrganizations } from '../context/OrganizationsContext'
import ErrorHandlingInterceptor from '../components/error-handling/ErrorHandlingInterceptor'
import ApplicationsContextProvider from '../context/ApplicationsContext'
import { SpinnerIcon } from '@sistemiv/s-components'
import { useAuth } from '../context/AuthContext'

const PrivateRoute: FC<{ children?: any }> = ({ children }) => {
  const { org } = useParams()
  const navigate = useNavigate()
  const { organizations, isLoadingOrganizations } = useOrganizations()
  const { isLoggedIn, loading } = useAuth()

  useEffect(() => {
    if (isLoadingOrganizations) {
      return
    }

    if (organizations.length === 0) {
      navigate('/not-authorized')
      return
    }

    if (!org) {
      navigate(`/${organizations.at(0)?.organizationCode}`)
      return
    }

    const foundOrg = organizations.find((organization) => organization.organizationCode == org)

    if (foundOrg) {
      return
    }

    navigate('/not-authorized')
  }, [organizations, org, navigate, isLoadingOrganizations])

  if (isLoadingOrganizations || loading) {
    return (
      <div className='w-full flex justify-center pt-5'>
        <SpinnerIcon className='text-sky-500 h-7 w-7' />
      </div>
    )
  }

  return isLoggedIn ? (
    <ErrorHandlingInterceptor>
      <ApplicationsContextProvider>{children}</ApplicationsContextProvider>
    </ErrorHandlingInterceptor>
  ) : (
    <Outlet />
  )
}

export default PrivateRoute
